const CELL = 10;
const SIZE = CELL * 9;

/**
 * One printable Sudoku grid as an SVG. With `solution`, the digits the puzzle left blank
 * are drawn in grey beside the bold givens, which is the answer key.
 */
export default function SudokuSheet({
  puzzle,
  solution,
  label,
}: {
  puzzle: readonly number[];
  solution?: readonly number[];
  label: string;
}) {
  const lines = Array.from({ length: 10 }, (_, i) => i);
  return (
    <svg
      aria-label={label}
      className="mx-auto block h-auto w-full max-w-[170mm]"
      role="img"
      viewBox={`-1 -1 ${SIZE + 2} ${SIZE + 2}`}
    >
      {lines.map((i) => (
        <g key={i}>
          <line
            stroke="#111111"
            strokeWidth={i % 3 === 0 ? 0.9 : 0.25}
            x1={i * CELL}
            x2={i * CELL}
            y1={0}
            y2={SIZE}
          />
          <line
            stroke="#111111"
            strokeWidth={i % 3 === 0 ? 0.9 : 0.25}
            x1={0}
            x2={SIZE}
            y1={i * CELL}
            y2={i * CELL}
          />
        </g>
      ))}
      {puzzle.map((given, cell) => {
        const digit = given || solution?.[cell] || 0;
        if (!digit) {
          return null;
        }
        return (
          <text
            fill={given ? "#111111" : "#777777"}
            fontSize={6.6}
            fontWeight={given ? 700 : 400}
            key={`${Math.floor(cell / 9)}-${cell % 9}`}
            textAnchor="middle"
            x={(cell % 9) * CELL + CELL / 2}
            y={Math.floor(cell / 9) * CELL + 7.3}
          >
            {digit}
          </text>
        );
      })}
    </svg>
  );
}
